import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";

const features = [
    {
        title: "Predictive Analytics",
        description: "Harness AI to forecast trends and predict future business outcomes.",
        imgUrl: "./img/services/ai-for-bi/predictive-analytics.jpg",
    },
    {
        title: "Natural Language Querying",
        description: "Simplify data analysis with AI-driven, conversational queries.",
        imgUrl: "./img/services/ai-for-bi/natural-language-querying.jpg",
    },
    {
        title: "Automated Reporting",
        description: "Generate insightful reports automatically with AI-powered tools.",
        imgUrl: "./img/services/ai-for-bi/automated-reporting.jpg",
    },
    {
        title: "Real-Time Data Insights",
        description: "Monitor key metrics and receive actionable insights in real time.",
        imgUrl: "./img/services/ai-for-bi/realtime-data-insights.jpg",
    },
    {
        title: "Data Visualization",
        description: "Create dynamic dashboards with AI-enhanced visualization tools.",
        imgUrl: "./img/services/ai-for-bi/data-visualization.png",
    },
    {
        title: "Anomaly Detection",
        description: "Identify outliers and irregularities in data with precision.",
        imgUrl: "./img/services/ai-for-bi/anomaly-detection.jpg",
    },
];


const AIforBI = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "AI for Business Intelligence", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="AI for Business Intelligence" description="Transform your decision-making process with AI-powered insights and analytics." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What is AI for Business Intelligence?</h2>
                            <p>
                                Artificial Intelligence (AI) in Business Intelligence (BI) enhances data-driven decision-making by providing actionable insights, automating analysis, and uncovering hidden trends in your data. It empowers businesses to operate with greater efficiency and agility.
                            </p>
                            <img
                                src="./img/services/ai-for-bi.jpg"
                                alt="AI for BI"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Our Key Services</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Benefits of AI for Business Intelligence</h2>
                            <ul>
                                <li>Enhance decision-making with accurate and timely data insights.</li>
                                <li>Save time by automating data analysis and reporting.</li>
                                <li>Improve operational efficiency by identifying and addressing anomalies.</li>
                                <li>Increase accessibility with intuitive, AI-powered tools.</li>
                                <li>Stay competitive with real-time monitoring and predictive analytics.</li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Revolutionize Your Business with AI for Business Intelligence</h2>
                            <p>
                                Unlock the full potential of your data. Contact us at{" "}
                                <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>.
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default AIforBI;
